import PortfolioTransformContainer from "../../../../components/pages/portfolio/portfolioPage/PortfolioTransform";

const PortfolioTransform = () => {
  return <PortfolioTransformContainer />;
};

export default PortfolioTransform;
